"use client"

import { HopOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HopOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HopOffIcon = component(Icon)({ as: HopOff })
